import { useMutation } from '@tanstack/react-query';
import { customFetcher } from './customFetcher';

export const useChangePassword = () => {
    const { mutateAsync, isPending } = useMutation<
        { ok: boolean },
        Error,
        { old_password: string; new_password: string }
    >({
        mutationFn: (body) =>
            customFetcher({ endpoint: '/accounts/change-password/', method: 'POST', body }),
    });
    return { changePassword: mutateAsync, isChanging: isPending };
};

export const useDeleteAccount = () => {
    const { mutateAsync, isPending } = useMutation<{ ok: boolean }, Error, { password: string }>({
        mutationFn: (body) =>
            customFetcher({ endpoint: '/accounts/delete/', method: 'POST', body }),
    });
    return { deleteAccount: mutateAsync, isDeleting: isPending };
};
